import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

import { BREAKPOINTS } from '../../../constants/breakpoints';
import StoryShimCursor from './StoryShimCursor';

// Body 02 [Full Image]
// This slide should only have an image which is full bleed;
const StoryBody02 = ({ bodyData }) => {
  const { image, imageMobile } = bodyData;

  if (!image) return null;

  const images = withArtDirection(getImage(imageMobile || image), [
    {
      image: getImage(image),
      media: `(min-width: ${BREAKPOINTS.tabletMD}px)`,
    },
  ]);

  return (
    <div className="story__body02">
      <StoryShimCursor />
      <div className="image">
        <GatsbyImage
          alt="Main cover"
          image={images}
          style={{ height: '100%' }}
        />
      </div>
    </div>
  );
};

StoryBody02.propTypes = {
  bodyData: PropTypes.object,
};

export default StoryBody02;
